"use strict";

var cov_8p6wexd0c = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\WordObject.js";
  var hash = "e4033c2e61540d9ceb615d74e2547177e15e86e5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\WordObject.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 26
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 11,
          column: 4
        }
      },
      "2": {
        start: {
          line: 14,
          column: 0
        },
        end: {
          line: 20,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 26
          },
          end: {
            line: 4,
            column: 27
          }
        },
        loc: {
          start: {
            line: 6,
            column: 6
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 6
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 7
          },
          end: {
            line: 9,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 7
          },
          end: {
            line: 9,
            column: 23
          }
        }, {
          start: {
            line: 9,
            column: 27
          },
          end: {
            line: 9,
            column: 46
          }
        }],
        line: 9
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "e4033c2e61540d9ceb615d74e2547177e15e86e5"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WordObject = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

cov_8p6wexd0c.s[0]++;

var WordObject = function WordObject(_ref) {
  var verseObject = _ref.verseObject;
  cov_8p6wexd0c.f[0]++;
  cov_8p6wexd0c.s[1]++;
  return _react.default.createElement(_react.default.Fragment, null, (cov_8p6wexd0c.b[0][0]++, verseObject.text) || (cov_8p6wexd0c.b[0][1]++, verseObject.content));
};

exports.WordObject = WordObject;
cov_8p6wexd0c.s[2]++;
WordObject.propTypes = {
  verseObject: _propTypes.default.shape({
    tag: _propTypes.default.string,
    type: _propTypes.default.string,
    content: _propTypes.default.string
  }).isRequired
};
var _default = WordObject;
exports.default = _default;